/**
 * Allows the model to call a tool directly.
 *
 * Use a string instead of a Symbol to allow for serializability.
 */
export const DIRECT_TOOL_CALL = 'AI_SDK_DIRECT_TOOL_CALL';
